import _slicedToArray from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/**
 * Is this a lookup object generated by Typescript, for a Typescript enum
 * generated by protobuf-ts?
 *
 * - No `const enum` (enum must not be inlined, we need reverse mapping).
 * - No string enum (we need int32 for protobuf).
 * - Must have a value for 0 (otherwise, we would need to support custom default values).
 */
export function isEnumObject(arg) {
  if (typeof arg != 'object' || arg === null) {
    return false;
  }

  if (!arg.hasOwnProperty(0)) {
    return false;
  }

  for (var _i = 0, _Object$keys = Object.keys(arg); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var num = parseInt(k);

    if (!Number.isNaN(num)) {
      // is there a name for the number?
      var nam = arg[num];
      if (nam === undefined) return false; // does the name resolve back to the number?

      if (arg[nam] !== num) return false;
    } else {
      // is there a number for the name?
      var _num = arg[k];
      if (_num === undefined) return false; // is it a string enum?

      if (typeof _num !== 'number') return false; // do we know the number?

      if (arg[_num] === undefined) return false;
    }
  }

  return true;
}
/**
 * Lists all values of a Typescript enum, as an array of objects with a "name"
 * property and a "number" property.
 *
 * Note that it is possible that a number appears more than once, because it is
 * possible to have aliases in an enum.
 *
 * Throws if the enum does not adhere to the rules of enums generated by
 * protobuf-ts. See `isEnumObject()`.
 */

export function listEnumValues(enumObject) {
  if (!isEnumObject(enumObject)) throw new Error("not a typescript enum object");
  var values = [];

  for (var _i2 = 0, _Object$entries = Object.entries(enumObject); _i2 < _Object$entries.length; _i2++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
        name = _Object$entries$_i[0],
        number = _Object$entries$_i[1];

    if (typeof number == "number") values.push({
      name: name,
      number: number
    });
  }

  return values;
}
/**
 * Lists the names of a Typescript enum.
 *
 * Throws if the enum does not adhere to the rules of enums generated by
 * protobuf-ts. See `isEnumObject()`.
 */

export function listEnumNames(enumObject) {
  return listEnumValues(enumObject).map(function (val) {
    return val.name;
  });
}
/**
 * Lists the numbers of a Typescript enum.
 *
 * Throws if the enum does not adhere to the rules of enums generated by
 * protobuf-ts. See `isEnumObject()`.
 */

export function listEnumNumbers(enumObject) {
  return listEnumValues(enumObject).map(function (val) {
    return val.number;
  }).filter(function (num, index, arr) {
    return arr.indexOf(num) == index;
  });
}